import http from '@/httpCommon/axiosClient';

class AuthService {
    login = async (params: any) => {
        const res = await http.post('/auth/login', params);
        return res?.data;
    };
}
export default new AuthService();
